<template>
  <div class="toast">
    <el-dialog :visible="isshow" :modal-append-to-body="false" @close="closeFn">
      <div slot="title" class="jumFpeedback_head">
        <img src="/img/logo.e85e07f3.png" alt="" />
        <b></b>
        <span>{{ title }}</span>
      </div>
      <div class="jumpFeedback_body" style="height: 500px; overflow-y: hidden; overflow-x: hidden">
        <div class="jumpFeedback_content" style="height: 450px; overflow: hidden; overflow-y: scroll" v-html="content"></div>
      </div>
      <div class="dialog-footer">
        <el-button type="info" @click="closeFn">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Agreement',
  props: {
    state: { type: Boolean, default: false },
    contentId: { type: Number, default: 1 }
  },
  data() {
    return {
      content: '',
      title: '',
      isshow: false
    }
  },
  watch: {
    contentId() { this.getcontent() },
    state() { this.isshow = this.state }
  },
  mounted() { this.getcontent() },
  methods: {
    closeFn() { this.$emit('closeState') },
    getcontent() {
      const timestamp = Date.parse(new Date())
      const params = { name: this.contentId === 1 ? '用户协议' : '隐私政策' }
      this.title = params.name
      axios({
        method: 'get',
        url: '/realNet/richText/selectRichText?_=' + timestamp,
        params
      }).then(res => {
        if (res.data.code === 200) {
          const content = res.data.result.content
          this.content = content[0].content
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
  .jumFpeedback_head {
    display: flex;
    align-items: center;
    img { height: 30px; }
    b { width: 1px; height: 20px; background: #ddd; margin: 0 10px; }
    span { font-size: 18px; font-weight: bold; }
  }

  .jumpFeedback_body {
    padding: 10px 20px;
  }

  .dialog-footer {
    text-align: center;
    padding: 10px 0;
  }
}
</style>
